import React from 'react';
import HelpIcon from '../assets/img/question-square.svg';

class DownloadManual extends React.Component {
    constructor(props) {
        super(props);

        this.downloadManual = this.downloadManual.bind(this);
    }

    downloadManual = (lang) => {
        var getUrl = window.location;
        var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
        var guideTab = window.open(baseUrl + "api/download/manual/" + lang + "/FileEx Manual", '_blank');
        guideTab.focus();
    }

    render() {
        return (
            <div id="manual" style={{ display: "flex", float: "left", alignItems: "center" }}>
                <div style={{ display: "flex" }}>
                    <div style={{ marginRight: "22px", display: "flex", alignItems: "center" }}>
                        <img
                            src={HelpIcon}
                            alt="Download Manual"
                            style={{ height: "1rem", position: "absolute" }}
                        />
                    </div>
                    <div>
                        {this.props.isUsaVersion && <a href="javascript:;" onClick={() => this.downloadManual("en")}>Manual</a>}
                        {!this.props.isUsaVersion && <> <a href="javascript:;" onClick={() => this.downloadManual("en")}>Manual</a> <a href="javascript:;" onClick={() => this.downloadManual("de")}>(de)</a></>}
                    </div>
                </div>
            </div>
        )
    }
}
export default DownloadManual;